import React, { Component } from 'react';
import { translate } from 'react-i18next';
import moment from 'moment';

// Services
import { currency } from 'services/currency';
import { getPayment, getLocalizeLabel, getSum } from 'services/payments';
import { dateWithTimezone } from 'src/services/date';

// Styles
import PT_Styles from './styles';

const filterControl = [
  {
    value: 'time',
    translateKey: 'report_table_time'
  },
  {
    value: 'certificate',
    translateKey: 'report_table_certificate'
  },
  {
    value: 'patient',
    translateKey: 'report_table_patient'
  },
  {
    value: 'general',
    translateKey: 'report_table_general'
  },
  {
    value: 'injections',
    translateKey: 'report_table_various'
  }
];

class PaymentTable extends Component {
  constructor(props) {
    super(props);
    const {
      table: { items }
    } = props;
    this.state = {
      activeFilter: 'time',
      direction: 'up',
      list: this.sortList('time', 'up'),
      generalSum: getSum(items, 'general'),
      injectionsSum: getSum(items, 'injections')
    };
    this.onChangeSort = this.onChangeSort.bind(this);
    this.sortList = this.sortList.bind(this);
  }

  onChangeSort(target) {
    const { activeFilter, direction } = this.state;
    if (activeFilter === target) {
      const direct = direction === 'up' ? 'down' : 'up';
      this.setState({
        direction: direct,
        list: this.sortList(target, direct)
      });
    } else {
      this.setState({
        activeFilter: target,
        direction: 'up',
        list: this.sortList(target, 'up')
      });
    }
  }

  sortList(activeFilter, direction) {
    const {
      table: { items }
    } = this.props;
    if (Array.isArray(items)) {
      return direction === 'up'
        ? items.sort((a, b) => (a[activeFilter] > b[activeFilter] ? 1 : -1))
        : items.sort((a, b) => (a[activeFilter] > b[activeFilter] ? -1 : 1));
    } else {
      return [];
    }
  }

  render() {
    const { i18n, table, onTableRowClick, tableCaptionKey } = this.props;
    const { generalSum, injectionsSum, activeFilter, direction, list } = this.state;
    const payment = getPayment(table.paymentMethod);
    const getTableCaption = () => {
      if (tableCaptionKey) {
        return i18n.t(tableCaptionKey);
      } else if (payment) {
        return getLocalizeLabel(payment, ' / ');
      }
    };

    return (
      <PT_Styles.TableCommonWrapper>
        {/* ──── Caption ─────────────────────────────────────────────────────────────────────── */}
        <PT_Styles.TableHeader>
          <PT_Styles.TableName>{getTableCaption()}</PT_Styles.TableName>
          <div>
            <span>{i18n.t('report_table_total')}:</span>
            <span className="big-font">{currency(generalSum + injectionsSum || 0).format()}</span>
          </div>
        </PT_Styles.TableHeader>

        <table>
          <thead>
            <tr>
              {filterControl.map(filter => (
                <td
                  key={filter.translateKey}
                  onClick={() => {
                    this.onChangeSort(filter.value);
                  }}
                  className={`${activeFilter === filter.value ? 'active ' + direction : ''}`}
                >
                  <span>{i18n.t(filter.translateKey)}</span>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6">
                      <path fill="#DBDCE1" fillRule="evenodd" d="M4 0l4 6H0z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6">
                      <path fill="#DBDCE1" fillRule="evenodd" d="M4 0l4 6H0z" />
                    </svg>
                  </div>
                </td>
              ))}
            </tr>
          </thead>

          <tbody>
            {list.map(row => (
              <tr key={`${row.time}-${row.patient}`} onClick={() => onTableRowClick(row)}>
                <td>
                  {moment(row.time).isValid() ? dateWithTimezone(row.time) : i18n.t('no_data')}
                </td>
                <td>{row.certificate}</td>
                <td>
                  <span className="last-name">{row.patientLastName} </span>
                  <span>{row.patientFirstName}</span>
                </td>
                <td className={row.general ? '' : 'zero'}>{currency(row.general || 0).format()}</td>
                <td className={row.injections ? '' : 'zero'}>
                  {currency(row.injections || 0).format()}
                </td>
              </tr>
            ))}
          </tbody>

          <tfoot>
            <tr>
              <td colSpan={3}>{i18n.t('report_table_sum')}:</td>
              <td className="big-font">{currency(generalSum || 0).format()}</td>
              <td className="big-font">{currency(injectionsSum || 0).format()}</td>
            </tr>
          </tfoot>
        </table>
      </PT_Styles.TableCommonWrapper>
    );
  }
}

export default translate()(PaymentTable);
